import Vue from "vue";
import Accordion from "./components/Accordion.vue";

/**
 * Set up config
 * **/
function init() {
  
  new Vue({
    el: "#tinzt-app",
    data() {
      return {
        menuIsOpen: false,
      }
    },
    components: {
      accordion: Accordion,
    },
    mounted() {      
    },
    methods: {
      toggleMenu() {
        this.menuIsOpen = !this.menuIsOpen;
      }
    }
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});